import React from "react";
export const ScreenContext = React.createContext();

export function ScreenSizeProvider({ children, value }) {
  return <ScreenContext.Provider value={value}>{children}</ScreenContext.Provider>;
}
